export default __webpack_public_path__ + "static/media/fan_0_off.e09331e5.svg";